export default __webpack_public_path__ + "fonts/h5-footer-logo.4d82246fd2dcfeeae08563f1bdcf8553.png";